import React from 'react'
import { StyleSheet, css } from 'aphrodite'
import { PropTypes } from 'prop-types'

const UIHighlightedTitle = ({
  dynamicStyle,
  value,
  backgroundColor = 'black',
  fontSize = '14px',
  lineHeight = '0.7em',
}) => {
  const style = styles(backgroundColor, fontSize, lineHeight)
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
      }}
    >
      <div className={css(style.container, dynamicStyle ? dynamicStyle : null)}>
        {value}
      </div>
    </div>
  )
}

const styles = (backgroundColor, fontSize, lineHeight) =>
  StyleSheet.create({
    container: {
      lineHeight: lineHeight,
      fontSize: fontSize,
      background: backgroundColor,
      padding: '0px 0.3em',
      width: 'fit-content',
      height: 'fit-content',
    },
  })

UIHighlightedTitle.propTypes = {
  dynamicStyle: PropTypes.object,
  value: PropTypes.string,
  backgroundColor: PropTypes.string,
  fontSize: PropTypes.string,
  lineHeight: PropTypes.string,
}

export default UIHighlightedTitle
